import moment from "moment";
import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { enumToMap } from "../../../../common/vue-helpers/modifiers/enum-modifiers";
import { HCDiscipline } from "../../../../enums/HCDisciplineEnum";
import { TaskService } from "../../../../services/task.service";
import { PatientService } from "../../../../services/patient.service";
import { formatDate } from "../../../../common/vue-helpers/modifiers/value-modifier";
import config from "../../../../common/config";

import EmptyTextHandler from "../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import ErrorMessageHandler from "../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import HCProfileDetails from "./HCProfileDetails/HCProfileDetails.vue";
import DateRangePicker from "../../../../resources-vue/vue-custom-elements/DateRangePicker/DateRangePicker.vue";
import HCTaskRow from "./HCTaskRow/HCTaskRow.vue";
import SortableTh from "../../../../resources-vue/vue-custom-elements/SortableTh/SortableTh.vue";

export default defineComponent({
    components: {
        EmptyTextHandler,
        ErrorMessageHandler,
        HCProfileDetails,
        DateRangePicker,
        HCTaskRow,
        SortableTh
    },
    props: {
        selectedPatientDetails: {
            default: null
        },
        agencyId: {
            type: String
        },
        application: {
            type: Number
        },
        patientId: {
            type: String
        }
    },
    data(vm) {
        return {
            _taskService: null as TaskService,
            _patientService: null as PatientService,
            disciplines: enumToMap(HCDiscipline),
            selectedDiscipline: null as number,
            isLoading: false as boolean,
            allTasks: [],
            isError: false as boolean,
            selectedEpisode: "All",
            episodeList: [],
            columns: 7 as number,
            showDateRange: false as boolean,
            range: "" as string,
            selectedEpisodeDetails: null,
            dateFrom: moment().subtract(60, "days").format("MM/DD/YYYY") as string,
            dateTo: moment().format("MM/DD/YYYY") as string,
            newDateRange: (moment().subtract(60, "days").format("MM/DD/YYYY") as string)
                .concat("-")
                .concat(moment().format("MM/DD/YYYY") as string),
            sortBy: "TaskName",
            sortOrder: "asc",
            moment,
            formatDate
        };
    },
    async created() {
        this._taskService = Container.instance.get(TaskService);
        this._patientService = Container.instance.get(PatientService);
    },

    mounted() {
        this.getBenefitPeriods();
        this.range = "";
        this.showDateRange = false;
        this.selectedEpisodeDetails = {
            startDate: this.selectedPatientDetails.startofCareDate,
            endDate: ""
        };
        this.getPatientTasks();
    },

    watch: {
        selectedDiscipline: {
            handler() {
                this.getPatientTasks();
            },
            deep: true
        }
    },

    computed: {
        hasData() {
            return this.allTasks.length > 0;
        },
        loadingCount() {
            return this.allTasks.length > 0 ? this.allTasks.length : config.pageSize;
        },
        showRangeText(): boolean {
            let dateRange = ["All", "DateRange"];
            return !dateRange.includes(this.selectedEpisode);
        }
    },

    methods: {
        async getPatientTasks() {
            try {
                this.isLoading = true;
                const payload = {
                    AgencyId: this.agencyId,
                    PatientId: this.patientId,
                    StartDate: this.showDateRange ? this.dateFrom : this.selectedEpisodeDetails.startDate,
                    EndDate: this.showDateRange ? this.dateTo : this.selectedEpisodeDetails.endDate,
                    Order: this.sortOrder,
                    SortBy: this.sortBy,
                    Discipline: this.selectedDiscipline ? this.selectedDiscipline : null,
                    Status: this.selectedPatientDetails.status,
                    DateRangeId: this.selectedEpisode
                };
                this.allTasks = (await this._taskService.getTasksByPatient(payload)) as any;
            } catch (err) {
                this.isError = true;
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async getBenefitPeriods() {
            const payload = {
                agencyId: this.agencyId,
                application: this.application,
                patientId: this.patientId
            };
            this.episodeList = (await this._patientService.getBenefitPeriods(payload)) as any;
        },

        handleSelectDateRange() {
            if (this.selectedEpisode == "DateRange") {
                this.showDateRange = true;
                this.range = "";
            } else {
                if (this.selectedEpisode == "All") {
                    this.range = "";
                    this.showDateRange = false;
                    this.selectedEpisodeDetails = {
                        startDate: this.selectedPatientDetails.startofCareDate,
                        endDate: ""
                    };
                } else {
                    this.showDateRange = false;
                    const data = this.episodeList.find((episode) => episode.title === this.selectedEpisode);
                    this.selectedEpisodeDetails = data;
                    this.range = `${moment(data.startDate).format("MM/DD/YYYY")} - ${moment(data.endDate).format("MM/DD/YYYY")}`;
                }
            }
            this.getPatientTasks();
        },
        setnewTaskDateRange(value: any) {
            this.dateFrom = String(value.split("-")[0]).trim();
            this.dateTo = String(value.split("-")[1]).trim();
            this.newDateRange = value;
            this.getPatientTasks();
        },
        sortByUpdated(value: string) {
            if (value != this.sortBy) {
                this.sortBy = value;
                this.getPatientTasks();
            }
        },

        sortOrderUpdated(value: string) {
            if (value != this.sortOrder) {
                this.sortOrder = value;
                this.getPatientTasks();
            }
        }
    }
});
